import { render, staticRenderFns } from "./NeededDocument.vue?vue&type=template&id=013d411f&scoped=true"
import script from "./NeededDocument.vue?vue&type=script&lang=ts"
export * from "./NeededDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d411f",
  null
  
)

export default component.exports